import {fullProfileTypes} from "./actionsType";

export const setFullProfilePlayerId = playerId => {
    return {
        type: fullProfileTypes.SET_PLAYER_ID,
        playerId: playerId,
    };
};
